
var loginData = null;

// localStorage.removeItem('doctor_user_details')
// localStorage.removeItem('doctor_jwt_token') 

if(localStorage.getItem('doctor_user_details') !== undefined && localStorage.getItem('doctor_user_details') !== null){ 
      loginData = JSON.parse(localStorage.getItem('doctor_user_details'))    
}




const initialState = {
      loginData: loginData,
} 



const loginDataReducer = (state = initialState.loginData, action) => {
    switch(action.type){
        case 'SIGN_IN':
            state = action.payload;  
            return state;
        case 'SIGN_IN':
            state = action.payload;  
            return state;
        case 'SIGN_OUT':
              return state - 1; 
        default:
              return state;

    }
};

export default loginDataReducer;